import React from 'react';
import { useTranslation } from 'react-i18next';

import { Colors, Typography, createClasses } from '@kp/react-ui';

interface SuggestedPrompt {
  key: string;
  icon?: string;
}

const SUGGESTED_PROMPTS: SuggestedPrompt[] = [
  { key: 'suggestedPrompts.buildings', icon: '🏢' },
  { key: 'suggestedPrompts.activeAlarms', icon: '🚨' },
  { key: 'suggestedPrompts.energyConsumption', icon: '⚡' },
  { key: 'suggestedPrompts.emissions', icon: '' },
];

const classes = createClasses({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '5px 11px',
    borderRadius: '6px',
    border: `1px solid ${Colors.Neutral.border}`,
    backgroundColor: Colors.Neutral.background,
    cursor: 'pointer',
    maxWidth: 'fit-content',
    transition: 'background-color 0.15s ease',
    ':hover': {
      backgroundColor: Colors.Neutral.backgroundHover,
    },
  },
  chipIcon: {
    fontSize: '14px',
    lineHeight: 1,
    flexShrink: 0,
  },
});

interface SuggestedPromptsProps {
  onSelect: (text: string) => void;
}

export const SuggestedPrompts: React.FC<SuggestedPromptsProps> = ({
  onSelect,
}) => {
  const { t } = useTranslation('chat');

  return (
    <div className={classes.root}>
      {SUGGESTED_PROMPTS.map(({ key, icon }) => (
        <button
          key={key}
          type="button"
          className={classes.chip}
          onClick={() => onSelect(t(key))}
        >
          <span className={classes.chipIcon}>{icon}</span>
          <Typography variant="bodySmall">{t(key)}</Typography>
        </button>
      ))}
    </div>
  );
};
